import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { siteDeviceInfoService } from './siteDeviceInfoService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(siteDeviceInfoService)
}

export const editor = site
